module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_8019.99917c0f.png";